export const kebabize = (value?: string): string | void =>
  value
    ?.replace(/[A-Z]/g, (str, i) => `${(i && '-') || ''}${str}`)
    .toLowerCase();

export const clean = (str: unknown): string =>
  typeof str === 'string' ? String(str) : '';

export const ascii = (str: string): string =>
  str
    .replace(/[áàâä]/g, 'a')
    .replace(/[éèêë]/g, 'e')
    .replace(/[íìîï]/g, 'i')
    .replace(/[óòôö]/g, 'o')
    .replace(/[úùûü]/g, 'u')
    .replace(/ç/g, 'c')
    .replace(/ñ/g, 'n')
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae');

export const trim = (str?: string): string =>
  str?.replace(/^\s+|\s+$/g, '') || '';

export const firstMatch = (sep: string | RegExp) => (
  str: string
): string | void => str.split(sep)?.[1];

export const generateHashFrom = (str?: string): string =>
  (str || '')
    .split('')
    .reduce((acc, value) => {
      const hash = (acc << 5) - acc + value.charCodeAt(0);
      return hash & hash;
    }, 0)
    .toString(36)
    .substr(2, 5);
